module.exports = __webpack_public_path__ + "static/media/PlosOnePub.69693f7a.png";